import { Theme, useTheme } from "@mui/material"
import type { SystemStyleObject } from "@mui/system"

type StylesInput<ClassKeys extends string, Props extends object> =
	| Record<ClassKeys, SystemStyleObject<Theme>>
	| ((theme: Theme, props: Props) => Record<ClassKeys, SystemStyleObject<Theme>>)

type StylesHook<ClassKeys extends string, Props extends object> = keyof Props extends never
	? (props?: Props) => Record<ClassKeys, SystemStyleObject<Theme>>
	: (props: Props) => Record<ClassKeys, SystemStyleObject<Theme>>

export function makeStyles<ClassKeys extends string, Props extends object = object>(
	stylesFn: StylesInput<ClassKeys, Props>
): StylesHook<ClassKeys, Props> {
	const useStyles = (props?: Props) => {
		const theme = useTheme()
		return typeof stylesFn === "function" ? stylesFn(theme, props as Props) : stylesFn
	}

	return useStyles as StylesHook<ClassKeys, Props>
}